/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import { useMediaQuery } from './use-media-query';

export const MOBILE_BREAKPOINT = '(max-width: 767px)';

/**
 * Reactively reports whether the viewport is at or below the mobile breakpoint.
 *
 * @returns `true` when the viewport matches the mobile media query.
 */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_BREAKPOINT);
}
